<template>
  <div class="  mx-0 bg-slate-50 h-dvh max-w-2xl"   >
    <NavTopBar 
      :isShowBack="isShowBack" 
      :isShowLogout="isShowLogout"
      v-if="isIndexPath"
      @logout="logout"/>
    <slot></slot>

    <!-- Global -->
    <GlobalLoading />
    <GlobalToast />
  </div>
</template>

<script setup lang="ts">
import { useAppStateStore } from '~/store-legacy/appState'
import { useTableStore } from '~~/store-legacy/table'
import { useAuthStore } from '~/store-legacy/auth'
import { useBootstrapStore } from "~/store-legacy/bootstrap";
import { getEndTimeDayjs } from "~/utils/checkExpireDate"
import _ from 'lodash'
import dayjs from "dayjs"

const $route = useRoute()
const $router = useRouter()
const appStateStore = useAppStateStore()
const authStore = useAuthStore()
const tableStore = useTableStore()
const bootstrapStore = useBootstrapStore();

const isShowBack = ref(true)
const isShowLogout = computed(() => false)


const isIndexPath = computed(() => {
  return $route.path !== "/pos";
});
watchEffect(()=>{
  setInterval(()=>{
    const token = authStore.token
    if(token){    
      if (dayjs().isAfter(getEndTimeDayjs(token.createdAt, token?.length)) && token?.length>0) {        
        authStore.clearToken()
      }
    }
  },1000*3)
})

onMounted(() => {
  const bootStrapStore = useBootstrapStore();
  bootStrapStore.init();
  bootStrapStore.run();
});

const logout = () => {
  tableStore.tableData = null
  $router.push('/')
}


</script>

<style scoped>

</style>